import { render, staticRenderFns } from "./CpfCnpj.vue?vue&type=template&id=bbb7a1fc"
import script from "./CpfCnpj.vue?vue&type=script&lang=js"
export * from "./CpfCnpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports